import script from "./logManager.vue?vue&type=script&setup=true&lang=js"
export * from "./logManager.vue?vue&type=script&setup=true&lang=js"

import "./logManager.vue?vue&type=style&index=0&id=6aad5ebd&lang=scss"

const __exports__ = script;

export default __exports__